module.exports = __webpack_public_path__ + "static/media/washable-rug.27dc85c1.jpg";